<template>
  <main v-if="loaded" class="login">
    <update-password
      v-if="passwordChange"
      :next-route="nextRoute"
    />

    <div
      v-else
      class="modal modal-sm active login__modal"
    >
      <div class="modal-container login__container">
        <header
          v-if="!('name' in $route.meta && $route.meta.name === 'ibpp')"
          class="modal-header login__header"
        >
          <img src="@/assets/img/home/logo_web.png" class="login__logo" />
        </header>

        <transition name="fade" mode="out-in">
          <router-view
            v-if="!passwordChange"
            class="modal-body"
            @success="logged($event)"
          />
        </transition>

      </div>

      <img
        v-if="('name' in $route.meta && $route.meta.name === 'ibpp')"
        src="@/assets/img/home/logo_web.png" class="login__logo login__logo--ibpp"
      />

      <small v-if="version" class="login__footer">
        Versão {{version}}
      </small>

      <p class="login__footer" style="font-size: 1em; width: 320px; text-align: center">
        Para uma melhor experiência, recomendamos o uso do navegador <b style="color: #56bdd2">Chrome</b>.
      </p>

      <div v-if="false" class="express-registration__help">
        <dr-help
          v-if="localActive"
          @closeHelp="close()"
        />

        <div class="express-registration__help__btn">
          <a
            @click="localActive = !localActive"
            class="btn btn-help"
          >
            Ajuda
            <dr-icon
              name="help"
              fill="#ffffff"
              color="#ffffff"
            />
          </a>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import updatePassword from '@/components/modals/updatePassword'
import EventBus from '@/globals/eventBus'
import { TRIAL_DAYS } from '@/globals/constants'
// import drHelp from '@/components/form/help'

export default {
  components: {
    updatePassword
    // drHelp
  },

  data () {
    return {
      passwordChange: false,
      nextRoute: null,
      loaded: false,
      version: null,
      localActive: ''
    }
  },

  watch: {
    '$route': function () {
      this.fn_HIDE_PROGRESS()
    }
  },
  mounted () {
    this.$http
      .get(`/version`)
      .then(res => (this.version = res.data))
      .catch(err => console.log(err))
      .finally(() => {
        this.loaded = true
        this.fn_HIDE_PROGRESS()
      })
  },

  methods: {
    close (v) {
      this.localActive = v
    },

    logged (ev) {
      if (!ev) {
        return
      }

      this.$http
        .get('/user', this.$store.getters.getAuthHeader)
        .then((res) => {
          this.passwordChange = res.data['has_forced_password_change']

          // Roles + Plans
          const { roles, 'created_at': registrationDate } = res.data

          const isPro = roles.some((role) => /doctor_pro/gi.test(role))

          const isPremium = roles.some((role) => /doctor_premium/gi.test(role)) ||
            roles.some((role) => /doctor_facilities/gi.test(role))

          const isTrial = !(this.$moment().diff(this.$moment(registrationDate), 'days') > TRIAL_DAYS)

          this.$store.dispatch('setPlan', { isPro, isPremium, isTrial })

          if (this.passwordChange) {
            this.nextRoute = ev
            return 'changePassword'
          }

          return 'login'
        })
        .then((res) => this.getSubscriptionPlan(res))
        .then((res) => {
          if (res === 'login') {
            const url = this.fn_IS_DOCTOR()
              ? 'doctor'
              : `secretary/doctor/${this.$route.params.doctorId}`

            return this.$http
              .get(url, this.$store.getters.getAuthHeader)
          }
        })
        .then((res) => {
          if (ev === 'doctor/') {
            this.checkDoctorProfileImage(res.data)
          }

          if (res) {
            const facetofaceOffices = res.data['doctor_offices']
              .filter(o => /facetoface/gi.test(o.type))

            const telemedicineOffices = res.data['doctor_offices']
              .filter(o => /telemedicine/gi.test(o.type))

            this.$store.dispatch('setUserOffices', [...facetofaceOffices, ...telemedicineOffices] || [])
            this.$store.dispatch('setCurrentOffice', facetofaceOffices.length > 0 ? facetofaceOffices[0].id : null)
          }

          this.$router.replace(`/${ev}`)
          EventBus.$emit('show-office-select-session')
        })
        .catch((err) => {
          if (/reset password/gi.test(err)) {
            this.passwordChange = true
          }
        })
    },

    checkDoctorProfileImage (data) {
      const profilePicture = data.profile_picture
        ? `${process.env.ROOT_API}/s3/file/doctor/${data.id}/profile_picture`
        : data.gender === 'F'
          ? require('@/assets/img/f_default.png')
          : require('@/assets/img/m_default.png')

      const profile = {
        id: data.id,
        name: data.user.name,
        displayName: data['display_name'],
        picture: profilePicture,
        email: data.user.email
      }

      this.$store.dispatch('setUserProfile', profile)
    },

    getSubscriptionPlan (res) {
      const url = '/doctor/doctor_subscription_plan'
      return new Promise((resolve) => {
        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((data) => {
            if (data.data['subscription_plan'].name === 'PREMIUM FREE') {
              this.$store.dispatch('setPlan', { isUpgrade: true })
            }

            resolve(res)
          })
          .catch(resolve(res))
      })
    }
  }
}
</script>
